<app-loading *ngIf="showLoading" [@fadeInOut]></app-loading>
<section id="main-section" *ngIf="!showLoading" [@fadeInOut]>

  <section id="top-nav">

    <app-top-nav  [logoUrl]="product.productLogo"></app-top-nav>

    <app-navbar></app-navbar>
  </section>
  <div class="hcp" id="hcp">
    <span>
      <i></i>
    </span>
    This is a medical content related to health care professionals (HCPs)
  </div>
  <app-hero-section style="position: relative; margin-top: 40px;" [variations]="product.variations" [productSlogan]="product.productSlogan" [keyMessages]="product.keyMessage" [imageUrl]="product.imageUrl && product.imageUrl "></app-hero-section>

  <app-active-ingredient [videoUrl]="product.videoUrl" [activeIngredients]="product.activeIngredient" [activeIngredientsDesc]="product.activeIngredientsDetails"></app-active-ingredient>

  <app-forms-concentraions [forms]="product.forms"></app-forms-concentraions>

  <app-indecations *ngIf="product.indications" [indications]="product.indications"></app-indecations>

  <app-interactions *ngIf="product.interactions" [interactions]="product.interactions"></app-interactions>

  <app-trials *ngIf="product.trial && product.trial.length > 0" [trials]="product.trial"></app-trials>

  <app-guidlines *ngIf="product.guidelines" [guideline]="product.guidelines"></app-guidlines>

  <app-references [references]="product.productReferences"></app-references>
  <app-related-products *ngIf="product.relatedProducts" [relatedProducts]="relatedProducts"></app-related-products>

  <!-- <app-download-app></app-download-app> -->
  <app-footer></app-footer>

  <div *ngIf="product.linkMessage" class="action-btn">
  <div class="container">
  <span><img src="../../../assets/calendar.svg"></span>
  <p>{{product.linkMessage}}</p>

  <a [attr.href]="product.linkUrL" target="_blank"> {{product.registerButton}} </a>
  </div>
  </div>

  </section>
